interface IntercomIdentityResponse {
  userHash: string;
}

export const intercomService = {
  async fetchUserSignature(
    apiGet: <T>(path: string) => Promise<T>,
  ): Promise<string> {
    const data = await apiGet<IntercomIdentityResponse>('/api/v1/intercom/identity');
    return data.userHash;
  },
};
